import React from 'react'
import CategoryPage from './CategoryPage'

const Women = () => {

    return <CategoryPage urlCategory="women" />
}

export default Women